// @ts-strict

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { BaseApiResponse, IChatUser } from '../../models/core-models';
import { IChatOnlineUsers } from './conversations.service.types';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ConversationsService {
  public mentionedUsername = new Subject<string>();
  public usersList$ = new BehaviorSubject<BaseApiResponse<IChatOnlineUsers> | undefined>(undefined);

  constructor(private http: HttpClient) {}

  public searchConversations(type: string, value: string): Observable<BaseApiResponse<{ users?: IChatUser[] }>> {
    const params = {
      type,
      value
    };

    return this.http.get(environment.apiUrl + `/private_chat/search`, { params });
  }

  public recentResearchResults(id: number[]): Observable<BaseApiResponse<{ users?: IChatUser[] }>> {
    const params = {
      'id[]': id
    };

    return this.http.get<BaseApiResponse<{ users?: IChatUser[] }>>(environment.apiUrl + `/private_chat/last_search`, { params });
  }

  public getPubliChatUsersList(): Observable<BaseApiResponse<IChatOnlineUsers>> {
    return this.http.get<BaseApiResponse<IChatOnlineUsers>>(environment.apiUrl + `/chat/online`).pipe(
      tap(res => {
        this.usersList$.next(res);
      })
    );
  }
}
